import type { CSSProperties } from 'react';
import { Icon } from '../core/Icon';

export interface PaginationProps {
    page?: number;
    pageCount?: number;
    /** Total de registros. Sem ele, exibe "Página X de Y". */
    total?: number;
    pageSize?: number;
    onChange?: (page: number) => void;
    style?: CSSProperties;
}

export function Pagination({ page = 1, pageCount = 1, total, pageSize = 25, onChange, style }: PaginationProps) {
    const seta = (direcao: -1 | 1, desabilitado: boolean) => (
        <button
            type="button" disabled={desabilitado}
            aria-label={direcao < 0 ? 'Página anterior' : 'Próxima página'}
            onClick={() => onChange?.(page + direcao)}
            style={{
                width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center',
                border: '1px solid var(--border)', background: 'var(--surface)', borderRadius: 'var(--radius-xs)',
                color: desabilitado ? 'var(--text-disabled)' : 'var(--neutral-700)',
                cursor: desabilitado ? 'not-allowed' : 'pointer',
            }}
        >
            <Icon name={direcao < 0 ? 'chevron-left' : 'chevron-right'} size={15} />
        </button>
    );

    const resumo = total != null
        ? `${Math.min((page - 1) * pageSize + 1, total)}–${Math.min(page * pageSize, total)} de ${total}`
        : `Página ${page} de ${pageCount}`;

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, fontFamily: 'var(--font-ui)', fontSize: 13, color: 'var(--text-secondary)', ...style }}>
            <span>{resumo}</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {seta(-1, page <= 1)}
                <span style={{ color: 'var(--text-primary)', fontWeight: 500, fontVariantNumeric: 'tabular-nums' }}>{page} / {pageCount}</span>
                {seta(1, page >= pageCount)}
            </div>
        </div>
    );
}
